const peding_resend_income_documents = 'PENDING_RESEND_INCOME_DOCUMENTS'
const reject = 'REJECTED'
const reanalyse = 'REANALYSE'

export { peding_resend_income_documents, reject, reanalyse }
